import React from 'react'
import { ISvg, Svg } from '../../Svg'

export const Appetize: React.FC<ISvg> = props => (
  <Svg viewBox="0 0 16 16" fill="none" {...props}>
    <path d="M3.0088 13L10.5088 5.50001L8.00885 3L0.508789 10.5L3.0088 13Z" fill="#7F899E" />
    <path d="M11.5633 6.55465L9.06332 9.05465L12.9912 12.9825L15.4912 10.4825L11.5633 6.55465Z" fill="#7F899E" />
  </Svg>
)
